import React, { useRef } from 'react'

import { Box, BoxProps } from 'ui/components/Box'

import { FileUploadContextProvider } from './FileUploadContext'
import { FileUploadDropzone } from './FileUploadDropzone'
import { FileUploadFileList } from './FileUploadFileList'
import { FileUploadInput } from './FileUploadInput'
import { FileUploadStrategy, UploadedFile } from './types'

type FileUploadProps = BoxProps & {
    value?: File[]
    onValueChange?: (files: File[]) => void
    accept?: string
    maxFiles?: number
    maxSize?: number
    disabled?: boolean
    multiple?: boolean
    name?: string
    required?: boolean
    strategy?: FileUploadStrategy
    onUploadSuccess?: (files: UploadedFile[]) => void
}

export const FileUpload: React.FC<FileUploadProps> = ({
    value,
    onValueChange,
    disabled = false,
    accept,
    name,
    multiple,
    required,
    maxSize,
    maxFiles = 1,
    strategy,
    onUploadSuccess,
    ...props
}) => {
    const inputRef = useRef<HTMLInputElement>(null)

    return (
        <Box {...props}>
            <FileUploadContextProvider
                value={value}
                onValueChange={onValueChange}
                disabled={disabled}
                inputRef={inputRef}
                accept={accept}
                name={name}
                multiple={multiple}
                required={required}
                maxSize={maxSize}
                maxFiles={maxFiles}
                strategy={strategy}
                onUploadSuccess={onUploadSuccess}
            >
                <FileUploadDropzone />
                <FileUploadInput ref={inputRef} />
                <FileUploadFileList mt="m" />
            </FileUploadContextProvider>
        </Box>
    )
}
